import { IContact } from 'clickNgo/entities/contact'

import { ContactTypeSelectorSegment } from '../configs'
import { CONTACT_LIST_FILTERS, ContactListFilterContext } from '../filters/contactListFilters'

export const filterByListType = (
  contacts: IContact[],
  listId: ContactTypeSelectorSegment,
  options: ContactListFilterContext
) => {
  return CONTACT_LIST_FILTERS[listId]?.(contacts, options) ?? contacts
}
